import {
  INVALID_SHORT_TIME_FORMAT,
  MAX_TIME_EXCEED_12_HOURS,
} from '../../constants/strings';
import { TIME_FORMAT_REGEX, toMinutes } from '../../utils/date';

const MAX_TIME_VALUE = 720;

const isValidTimeFormat = (value) => TIME_FORMAT_REGEX.test(value);

const getErrorMsg = (value) =>
  !isValidTimeFormat(value)
    ? INVALID_SHORT_TIME_FORMAT
    : toMinutes(value) > MAX_TIME_VALUE
      ? MAX_TIME_EXCEED_12_HOURS
      : '';

export const validateFormValues = ({ waveCutOff, departTime }) => {
  const errors = {};

  if (waveCutOff) {
    const errorMsg = getErrorMsg(waveCutOff);
    if (errorMsg) {
      errors.waveCutOff = errorMsg;
    }
  }
  if (departTime) {
    const errorMsg = getErrorMsg(departTime);
    if (errorMsg) {
      errors.departTime = errorMsg;
    }
  }
  return errors;
};
